//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '5.2.0'.
//
package blazern.lexisoup.graphql.model.selections

import blazern.lexisoup.graphql.model.fragment.selections.SentenceFieldsSelections
import blazern.lexisoup.graphql.model.type.GraphQLString
import blazern.lexisoup.graphql.model.type.Query
import blazern.lexisoup.graphql.model.type.Sentence
import blazern.lexisoup.graphql.model.type.Suggestion
import com.apollographql.apollo.api.CompiledArgument
import com.apollographql.apollo.api.CompiledField
import com.apollographql.apollo.api.CompiledFragment
import com.apollographql.apollo.api.CompiledSelection
import com.apollographql.apollo.api.CompiledVariable
import com.apollographql.apollo.api.list
import com.apollographql.apollo.api.notNull
import kotlin.collections.List

public object SuggestionsQuerySelections {
  private val __translations: List<CompiledSelection> = listOf(
        CompiledField.Builder(
          name = "__typename",
          type = GraphQLString.type.notNull()
        ).build(),
        CompiledFragment.Builder(
          typeCondition = "Sentence",
          possibleTypesSet = setOf("Sentence")
        ).selections(SentenceFieldsSelections.__root)
        .build()
      )

  private val __suggestions: List<CompiledSelection> = listOf(
        CompiledField.Builder(
          name = "__typename",
          type = GraphQLString.type.notNull()
        ).build(),
        CompiledField.Builder(
          name = "text",
          type = GraphQLString.type.notNull()
        ).build(),
        CompiledField.Builder(
          name = "langIso3",
          type = GraphQLString.type.notNull()
        ).build(),
        CompiledField.Builder(
          name = "source",
          type = GraphQLString.type.notNull()
        ).build(),
        CompiledField.Builder(
          name = "translations",
          type = Sentence.type.notNull().list().notNull()
        ).selections(__translations)
        .build()
      )

  public val __root: List<CompiledSelection> = listOf(
        CompiledField.Builder(
          name = "suggestions",
          type = Suggestion.type.notNull().list().notNull()
        ).arguments(listOf(
          CompiledArgument.Builder(Query.__suggestions_langFromIso3).value(CompiledVariable("langFromIso3")).build(),
          CompiledArgument.Builder(Query.__suggestions_langToIso3).value(CompiledVariable("langToIso3")).build(),
          CompiledArgument.Builder(Query.__suggestions_query).value(CompiledVariable("query")).build()
        ))
        .selections(__suggestions)
        .build()
      )
}
